// src/pages/ConfidentialitePage.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Footer from '../components/Footer';

const ConfidentialitePage = () => {
  const { t, i18n } = useTranslation();
  const isNotFr = i18n.language !== 'fr';

  return (
    <div className="pt-24 pb-12">
      <Helmet>
        <title>{t('legal.privacy.meta.title')}</title>
        <meta name="description" content={t('legal.privacy.meta.description')} />
        <link rel="canonical" href="https://hmonghearts.com/confidentialite" />
      </Helmet>
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl font-bold mb-8 dark:text-gray-100">{t('legal.privacy.title')}</h1>

        {isNotFr && (
          <div className="mb-6 p-4 bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800 rounded-xl text-sm text-amber-800 dark:text-amber-200">
            {t('legal.disclaimer')}
          </div>
        )}

        <div className="prose prose-gray max-w-none space-y-6 text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.privacy.article1.title')}
            </h2>
            <p dangerouslySetInnerHTML={{ __html: t('legal.privacy.article1.p1') }} />
            <ul className="list-none space-y-1 mt-2">
              <li>
                <strong>Archion Consulting</strong> — Entrepreneur individuel
              </li>
              <li>
                <strong>SIRET :</strong> 948 312 632 00037
              </li>
              <li>
                <strong>Email :</strong>{' '}
                <a
                  href="mailto:contact@hmonghearts.com"
                  className="text-rose-600 dark:text-rose-400 hover:underline"
                >
                  contact@hmonghearts.com
                </a>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.privacy.article2.title')}
            </h2>
            <p>{t('legal.privacy.article2.p1')}</p>
            <p className="font-semibold mt-3">{t('legal.privacy.article2.subtitle1')}</p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li>{t('legal.privacy.article2.item1')}</li>
              <li>{t('legal.privacy.article2.item2')}</li>
              <li>{t('legal.privacy.article2.item3')}</li>
              <li>{t('legal.privacy.article2.item4')}</li>
              <li>{t('legal.privacy.article2.item5')}</li>
            </ul>
            <p className="font-semibold mt-3">{t('legal.privacy.article2.subtitle2')}</p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li>{t('legal.privacy.article2.item6')}</li>
              <li>{t('legal.privacy.article2.item7')}</li>
              <li>{t('legal.privacy.article2.item8')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.privacy.article3.title')}
            </h2>
            <p>{t('legal.privacy.article3.p1')}</p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li>{t('legal.privacy.article3.item1')}</li>
              <li>{t('legal.privacy.article3.item2')}</li>
              <li>{t('legal.privacy.article3.item3')}</li>
              <li>{t('legal.privacy.article3.item4')}</li>
              <li>{t('legal.privacy.article3.item5')}</li>
              <li>{t('legal.privacy.article3.item6')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.privacy.article4.title')}
            </h2>
            <p>{t('legal.privacy.article4.p1')}</p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article4.item1') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article4.item2') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article4.item3') }} />
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.privacy.article5.title')}
            </h2>
            <p>{t('legal.privacy.article5.p1')}</p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li>{t('legal.privacy.article5.item1')}</li>
              <li>{t('legal.privacy.article5.item2')}</li>
            </ul>
            <p className="mt-2">{t('legal.privacy.article5.p2')}</p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article5.item3') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article5.item4') }} />
            </ul>
            <p className="mt-2">{t('legal.privacy.article5.p3')}</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.privacy.article6.title')}
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article6.item1') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article6.item2') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article6.item3') }} />
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.privacy.article7.title')}
            </h2>
            <p>{t('legal.privacy.article7.p1')}</p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article7.item1') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article7.item2') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article7.item3') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article7.item4') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article7.item5') }} />
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article7.item6') }} />
            </ul>
            <p className="mt-2">
              {t('legal.privacy.article7.p2')}{' '}
              <a
                href="mailto:contact@hmonghearts.com"
                className="text-rose-600 dark:text-rose-400 hover:underline"
              >
                contact@hmonghearts.com
              </a>
              . {t('legal.privacy.article7.p3')}
            </p>
            <p className="mt-2">
              {t('legal.privacy.article7.p4')}{' '}
              <a
                href="https://www.cnil.fr"
                className="text-rose-600 dark:text-rose-400 hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.cnil.fr
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.privacy.article8.title')}
            </h2>
            <p>{t('legal.privacy.article8.p1')}</p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li dangerouslySetInnerHTML={{ __html: t('legal.privacy.article8.item1') }} />
            </ul>
            <p className="mt-2">{t('legal.privacy.article8.p2')}</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.privacy.article9.title')}
            </h2>
            <p>{t('legal.privacy.article9.p1')}</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.privacy.article10.title')}
            </h2>
            <p>{t('legal.privacy.article10.p1')}</p>
            <p className="mt-2">
              {t('legal.privacy.article10.p2')}{' '}
              <a
                href="mailto:contact@hmonghearts.com"
                className="text-rose-600 dark:text-rose-400 hover:underline"
              >
                contact@hmonghearts.com
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.privacy.article11.title')}
            </h2>
            <p>{t('legal.privacy.article11.p1')}</p>
          </section>

          <p className="text-gray-400 text-xs mt-8">{t('legal.privacy.lastUpdated')}</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ConfidentialitePage;
